module.exports = __webpack_public_path__ + "img/a_soja.249937cb.svg";